import dayjs from 'dayjs';
import dayJsDuration from 'dayjs/plugin/duration.js';
import { Locales } from '../strings/Locales.js';
dayjs.extend(dayJsDuration);
export var getFormatedTimeUntilLogout = function getFormatedTimeUntilLogout(duration) {
    var parsedDuration = parse(duration);
    return humanize(parsedDuration);
};
/* * * * * * * * * * * * * *
 *   Private functions
 * * * * * * * * * ** * * * */ var parse = function parse(duration) {
    var milliseconds = duration.asMilliseconds();
    if (milliseconds < 1000) {
        return milliseconds > 500 ? {
            seconds: 1
        } : {
            milliseconds: milliseconds
        };
    }
    var secondsLeft = duration.asSeconds();
    var durationMap = {};
    var hours = duration.hours();
    if (hours) {
        durationMap.hours = hours;
        secondsLeft -= hours * 60 * 60;
    }
    var minutes = duration.minutes();
    if (minutes) {
        durationMap.minutes = minutes;
        secondsLeft -= minutes * 60;
    }
    var seconds = duration.seconds();
    if (seconds) {
        durationMap.seconds = seconds;
        secondsLeft -= seconds;
    }
    return durationMap;
};
var humanize = function humanize(durationInformation) {
    var milliseconds = durationInformation.milliseconds, seconds = durationInformation.seconds, minutes = durationInformation.minutes, hours = durationInformation.hours;
    var addSpaceIfNeeded = function addSpaceIfNeeded() {
        if (result.length) {
            result += ' ';
        }
    };
    var result = '';
    if (hours) {
        addSpaceIfNeeded();
        result += hours + ' ' + Locales.format('hours', {
            smart_count: hours
        });
    }
    if (minutes) {
        addSpaceIfNeeded();
        result += minutes + ' ' + Locales.format('minutes', {
            smart_count: minutes
        });
    }
    if (seconds) {
        addSpaceIfNeeded();
        result += seconds + ' ' + Locales.format('seconds', {
            smart_count: seconds
        });
    }
    if (result.length && milliseconds) {
        return milliseconds + ' ' + Locales.format('milliseconds', {
            smart_count: milliseconds
        });
    }
    return result;
};

//# sourceMappingURL=GetFormatedTimeUntilLogout.js.map